var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Choice as SkapaChoice, ChoiceItem as SkapaChoiceItem } from '@ingka/choice-webc/passive.js';
import { Text } from '@ingka/common-styles-webc';
import SortListOptionsEnum from '../../enums/SortListOptionsEnum.js';
import LabelUtility from '../../utilities/LabelUtility.js';
/**
 * @event change When sort option is changed.
 */
export default class SortListCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // Selected option
        this.selected = null;
    }
    async connectedCallback() {
        this.customElements.define('skapa-choice', SkapaChoice);
        this.customElements.define('skapa-choice-item', SkapaChoiceItem);
        super.connectedCallback();
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `<style>
				h2 {
					margin-top: 0;
					margin-bottom: ${this.theme.spacing.space200 / 16}rem;
				}
				${Text.CSS}
			</style>
			${this.getHeading()}${this.getChoice()}`;
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        const translations = this.translations
            ? this.translations
            : this.localizedInformation?.translations;
        return translations;
    }
    getHeading() {
        return html `<h2 class="${Text.classnames({ heading: { m: true } })}">
			${this.getTranslations().pickingListSortTitle}
		</h2>`;
    }
    getChoice() {
        return html `<skapa-choice subtle
			>${Object.values(SortListOptionsEnum).map((option) => this.getChoiceItem(option))}</skapa-choice
		> `;
    }
    getChoiceItem(option) {
        const selectedOption = this.selected || SortListOptionsEnum.default;
        return html `
			<skapa-choice-item
				@choice-item-select="${() => {
            this.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { selected: option } }));
        }}"
				.selected="${selectedOption === option}"
			>
				<span slot="title">${LabelUtility.getLabel(option, this.getTranslations())}</span>
			</skapa-choice-item>
		`;
    }
}
__decorate([
    property({ type: Object, required: true })
], SortListCard.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], SortListCard.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], SortListCard.prototype, "translations", void 0);
__decorate([
    property({ type: String })
], SortListCard.prototype, "selected", void 0);
//# sourceMappingURL=SortListCard.js.map